// TODO: enable eslint when we're using this again
/* eslint-disable */
// import store from '@/store/store';
// import introJs from 'intro.js/intro';

export default class IntroUtils {
  static get COMPLETED() { return 'Completed'; }

  static shouldShowIntro(key, forceShow = false) {
    // if (localStorage.getItem('PwrLab:Intro:Enabled') === '0') {
    //   return false;
    // }
    //
    // if (store.state.user.memberType === 'Trainer') {
    //   return forceShow;
    // }
    //
    // if (forceShow || !key) {
    //   return true;
    // }
    //
    // return localStorage.getItem(key) !== IntroUtils.COMPLETED;

    // TODO: re-enable this when we are ready to show it again.
    return false;
  }

  static showIntro(options, key = undefined) {
    const intro = introJs();
    intro.setOptions(options);
    intro.start();

    if (key) {
      const storeIntroCompleted = () => {
        localStorage.setItem(key, IntroUtils.COMPLETED);
      };
      intro.oncomplete(storeIntroCompleted);
      intro.onexit(storeIntroCompleted);
    }
  }

  static showIntroIfNecessary(options, key = undefined, forceShow = false) {
    if (this.shouldShowIntro(key, forceShow)) {
      this.showIntro(options, key);
    }
  }
}
